import React from 'react';
import Grid from '@material-ui/core/Grid';
import Section from './Section';
const Column = props => {
  return props.children.map((section, i) => /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    key: i,
    "data-testid": "column-".concat(i)
  }, /*#__PURE__*/React.createElement(Section, null, section)));
};
export default Column;